//LMIT-604
import React, { Component } from 'react';
import './css/admin-page.css';
import UploadLightbox from './upload-lightbox.js';

class AdminPage extends Component {
	constructor(props){
		super(props);
		var dt = new Date();
		var monthName = window.l10n[window.locale]["lessee.monthnames"][dt.getMonth()];
		this.state = {
			strDate: monthName + " " + dt.getDate() + ", " + dt.getFullYear(),
			lesseeName: "John Smith",
			isActiveUploadLightbox: false,
			dbFields: {},
			ajaxLoadingState : ""
		};
		//this.uploadFile = this.uploadFile.bind(this);
		this.showUploadLightbox = this.showUploadLightbox.bind(this);
		this.dismissUploadLightbox = this.dismissUploadLightbox.bind(this);
		//console.log("LesseePage optaToken=" + window.optaToken);
	}

	camelCase(str) {
		var retVal = "";
		for (var i = 0; i < str.length; i++) {
			var c = str.charAt(i).toLowerCase();
			if (i === 0 || str.charAt(i - 1) === " ") c = c.toUpperCase();
			retVal += c;
		}
		retVal = retVal.replace(/bmw/gi, "BMW");
		return retVal;
	}

	getClassForLogo() {
		var v = ("" + this.state.dbFields["Make"]).toLowerCase();
		if (v.match(/grand\s*-?\s*touring/i)) return "grandtouring";
		return v;
	}
	
	preprocessAdminPayload(jsonO){
		//Admin payload
		jsonO["FirstName"] = jsonO["vin"];
		jsonO["LastName"] = "";		
		jsonO["VIN"] = "";
		jsonO["Make"] = this.camelCase(jsonO["oem"]); //drive the logo
		jsonO["useroem"] = this.camelCase(jsonO["oem"]); //drive the file destination on the back-end
		
		return jsonO;
	}

	getAdminDetailsFromServer(){
		var t = this;
		var formData = new FormData();
		formData.append("optatoken", window.optaAdminToken);

		var xhr = new XMLHttpRequest();
		xhr.onreadystatechange = function () {
			if (this.readyState === 4) {
				if (this.status === 200) {
					if (this.responseText) {
						var responseJson = JSON.parse(this.responseText);
						//console.log(responseJson);
						var dbFields = t.preprocessAdminPayload(responseJson);
						t.setState({ dbFields: dbFields, ajaxLoadingState: "" });
					}
				} else {
					//go to admin landing page
					t.setState({ ajaxLoadingState: "" });
					var pathName = "admin-" + window.locale;
					//console.log("Token expired. Going to login page: '" + pathName + "'");
					window.optatoken = "";
					window.optaAdmintoken = "";
					window.location.href = pathName;
				}
			}
		};

		xhr.open('post', window.AppConfig["url-lesseedetails"], true);
		try {
			this.setState({ ajaxLoadingState: "loading" });
			xhr.send(formData);
		} catch (e) {
			console.log("Failed to get admin details:" + e);
		}

	}


	componentDidMount() {
		this.getAdminDetailsFromServer();
	}

	componentWillUnmount() {
	}

	uploadFile(e) {
		console.log("Uploading file event: %o", e);
	}

	showUploadLightbox() {
		this.setState({ isActiveUploadLightbox: true });
	}

	dismissUploadLightbox() {
		this.setState({ isActiveUploadLightbox: false });
	}

	render() {
		let uploadLightbox;
		if (this.state.isActiveUploadLightbox) {
			uploadLightbox = < UploadLightbox fnDismiss={this.dismissUploadLightbox} useroem={this.state.dbFields["useroem"]} />;
		}
		
		return (
			<div id="admin-page">
				<div className={"ajax-spinner-lightbox " + this.state.ajaxLoadingState } />
				<div className={"admin-logo " + ("" + window.locale).toLowerCase() + " " + this.getClassForLogo()} />
				<div className="admin-date" >{this.state.strDate}</div>
				<div className="admin-frame">
					<div className="admin-welcome">{ window.l10n[window.locale]["lessee.welcome"] }</div>
					<div className="admin-full-name">{this.state.dbFields["FirstName"]} {this.state.dbFields["LastName"]}</div>
					<hr className="admin-divider"/>

					<div className="admin-renews-container">
						<div className="caption2">
							<br/><br/>
							<input
								className="upload-btn"
								type="button"
								value={window.l10n[window.locale]["lessee.uploadfiles"]}
								onClick={this.showUploadLightbox}
							/>
						</div>
					</div>
					{uploadLightbox}					
				</div>
			</div>

		);
	}
}
export default AdminPage;



// WEBPACK FOOTER //
// ./src/components/admin-page.js